import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import { decodeData } from "../../Constants/constants";

class CandidateBackgroundVerification extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      Agency_rows: [],
      verification_agency_id: '',
      selectedEmployeeId: null,
      selectedRows: [],
      agency_verification_status: '',
      decodedData: [],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetVerificationAgencyList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetEmployeesByBackgroundVerification`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          agency_verification_status: this.state.agency_verification_status,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  handleSelectStatus = (selectedOption) => {
    this.setState({
      agency_verification_status: selectedOption.value,
    }, () => {
      this.GetList();
    });
  };



  handleSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    if (!this.state.verification_agency_id) {
      Swal.fire({
        icon: "warning",
        title: "<strong>Oops..</strong>",
        text: "Please select Agency !!",
        timer: 2000,
        showConfirmButton: true,
        allowOutsideClick: false,
      });
      return;
    }
    var formData = {
      verification_agency_id: this.state.verification_agency_id,
      employee_id: this.state.selectedRows,
    };


    axios.post(`${apiURL}Masters/AssignAgency`, formData, { headers }).then((response) => {
      const { success } = response.data;
      if (success === true && this.state.verification_agency_id === 0) {
        this.setState({
          verification_agency_id: '',
          employee_id: ''
        })

        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
      }

    })
  };
  handleSelectAgency = (selectedOption) => {
    this.setState({
      verification_agency_id: selectedOption.value,
    });
  };



  handleInputSearch = (e) => {
    this.GetList();
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    }, () => {
      if (this.state.keyword === "") {
        this.GetList();
      }
    });
  };
  handleClearAll = () => {
    this.setState({
      employee_id: 0,
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
    }
      , () => {
        this.GetList();
      });
  };

  handleCheckboxChange = (employeeId) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(employeeId)) {
        selectedRows.splice(selectedRows.indexOf(employeeId), 1);
      } else {
        selectedRows.push(employeeId);
      }

      return { selectedRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === 'select-all') {
      this.setState({ selectedRows: this.state.rows.map((row) => row.employee_id) });
    } else if (action === 'deselect-all') {
      this.setState({ selectedRows: [] });
    }
  };
  GetVerificationAgencyList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetVerificationAgencyList `, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Agency_rows: data.data.map((row) => ({
              value: row.verification_agency_id,
              label: row.verification_agency_name
            }))
          }));
        }
      });
  }

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
          this.GetVerificationAgencyList();
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
          this.GetVerificationAgencyList();
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
        this.GetVerificationAgencyList();
      }
    );
  };

  handleDropdownItemClick = (value, row) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    var formData = {
      agency_verification_status: value,
      verification_agency_id: row.verification_agency_id,
      employee_id: row.employee_id,
    }

    axios.post(`${apiURL}Masters/UpdateVerificationByCompany`, formData, { headers }).then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
      }

    })

  };
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500];
    const options = [
      { value: '', label: 'Show All' },
      { value: '0', label: 'UnAssign' },
      { value: '1', label: 'Pending' },
      // { value: '2', label: 'Verified' },
      { value: '3', label: 'Issue' },
    ];
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#007bff' : '#fff',
        color: state.isSelected ? '#fff' : '#333',
        // padding: 10,
        ':hover': {
          backgroundColor: '#007bff',
          color: '#FFF',
        },
      }),
    };
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Background Verification`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header align-items-center d-flex">
                    <div className='col-md-3'>
                      <label htmlFor="keyword">Enter keyword</label>
                      <div className="input-group">
                        <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by keyword" />
                        <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row" style={{ marginLeft: "20px" }}>
                        <div className='col-md-4'>
                          <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                        </div>
                        <div className='col-md-4'>
                          <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                        </div>
                        <div className='col-md-4'>
                          <div>
                            <label>Check Status</label>
                          </div>
                          <Select options={options} value={this.state.selectOption} onChange={this.handleSelectStatus} styles={customStyles} placeholder="Select Status" />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-3'>
                      <div style={{ float: "right" }}>
                        <label>Assign Agency's</label>
                        <div></div>
                        <button
                          data-bs-toggle="modal"
                          data-bs-target={`#varyingcontentModal`}
                          type="button"
                          className={`btn btn-info btn-label waves-effect right waves-light ${(this.state.selectedRows.length === 0) ? 'disabled' : ''}`}>
                          <i className="ri-user-settings-line label-icon align-middle fs-16 ms-2" />
                          Assign Agency
                        </button>
                      </div>

                    </div>
                    <div className="modal fade" id={`varyingcontentModal`} tabIndex={-1} aria-labelledby="varyingcontentModalLabel" aria-hidden="true">
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="varyingcontentModalLabel">Select Agency</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                          </div>
                          <div className="modal-body">
                            <form>
                              <div className="mb-3">
                                <Select onChange={this.handleSelectAgency} hint={`Select Agency`} options={this.state.Agency_rows} />
                              </div>
                            </form>
                          </div>
                          <div className="modal-footer">
                            <button type="button" className="btn btn-light" data-bs-dismiss="modal">Close</button>
                            <button
                              type="button"
                              onClick={() => this.handleSubmit(this.state.selectedEmployeeId)}
                              className="btn btn-success"
                              data-bs-dismiss="modal"
                            >
                              Assign
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table className={`table table-bordered table-hover`}>
                      <thead className="table-light">
                        <tr>
                          <th>
                            <div className="btn-group" style={{ background: "rgb(221 224 227)" }}>
                              <button type="button" className="btn">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={this.state.selectedRows.length === this.state.rows.length}
                                  onChange={this.handleSelectAll}
                                />
                              </button>
                              <button
                                type="button"
                                className="btn dropdown-toggle dropdown-toggle-split"
                                id="dropdownMenuReference"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                data-bs-reference="parent"
                                style={{ background: "#c7c7c7" }}
                              >
                                <span className="visually-hidden">Toggle Dropdown</span>
                              </button>
                              <ul className="dropdown-menu" aria-labelledby="dropdownMenuReference">
                                <li>
                                  <button className="dropdown-item" onClick={() => this.handleSelectAllDropdown('select-all')}>
                                    Select All
                                  </button>
                                </li>
                                <li>
                                  <button className="dropdown-item" onClick={() => this.handleSelectAllDropdown('deselect-all')}>
                                    Deselect All
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </th>
                          <th>Employee Code</th>
                          <th>Employee Name</th>
                          <th>Employee Mobile Number</th>
                          <th>Employee Email Address</th>
                          <th>Assigned Agency's</th>
                          <th>Employee Status</th>

                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      {this.state.rows.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan={11}>
                              <NoRecords />
                            </td>
                          </tr>
                        </tbody>
                      ) :
                        <tbody>
                          {this.state.rows.map((row) => {
                            return (
                              <tr key={row.employee_id}>
                                <td >
                                  <div className="d-flex justify-content-center align-items-center">
                                    <input type="checkbox" className="form-check-input" checked={this.state.selectedRows.includes(row.employee_id)} onChange={() => this.handleCheckboxChange(row.employee_id)} />
                                  </div>
                                </td>
                                <td>{row.employee_code}</td>
                                <td>
                                  <NavLink to={`/Profile/${row.employee_id}`}>
                                    {row.employee_name}
                                  </NavLink>
                                </td>
                                <td>{row.employee_mobile_number}</td>
                                <td>{row.employee_email_address}</td>
                                <td>{row.verification_agency_name}</td>
                                <td><span className={`badge bg-${row.agency_verification_status_class}`} >{row.agency_verification_status_label}</span></td>
                                <td className="d-flex justify-content-around">

                                  <div className="btn-group">
                                    <button type="button" className="btn btn-success">Action's</button>
                                    <button type="button" className="btn btn-success dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                    <div className="dropdown-menu">
                                      <button className="dropdown-item" onClick={() => this.handleDropdownItemClick(0, row)}>UnAssign</button>
                                      <button className="dropdown-item" onClick={() => this.handleDropdownItemClick(1, row)}>Pending</button>
                                      <button className="dropdown-item" onClick={() => this.handleDropdownItemClick(2, row)}>Verified</button>
                                      <button className="dropdown-item" onClick={() => this.handleDropdownItemClick(3, row)}>Issue</button>
                                    </div>
                                  </div>

                                </td>
                              </tr>
                            );
                          })}
                        </tbody>}
                      <tfoot className="table-light">
                        <tr>
                          <th colSpan={8}>
                            <div className="d-flex justify-content-between">
                              <button
                                disabled={
                                  this.state.prev === false &&
                                    this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handlePrev()}
                                className={`btn btn-warning btn-label waves-effect waves-light`}
                              >
                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                Previous
                              </button>
                              <div
                                className="col-md-4"
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                {
                                  <small>
                                    Total Records: {this.state.total_records} |
                                    Total Pages: {this.state.total_pages} |
                                    Current Page: {this.state.page}
                                  </small>
                                }
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={(e) => this.handleChange(e)}
                                >
                                  {Array.from(
                                    { length: this.state.total_pages },
                                    (_, i) => (
                                      <option
                                        selected={this.state.page === i + 1}
                                        key={i}
                                        value={i + 1}
                                      >
                                        Page {i + 1}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={this.handleLimitChange}
                                  value={this.state.limit}
                                >
                                  <option value={this.state.total_records}>All</option>
                                  {limitOptions.map((option) => (
                                    <option key={option} value={option}>
                                      Limit {option}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <button
                                disabled={
                                  this.state.next === false &&
                                    this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handleNext()}
                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                              >
                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                Next
                              </button>
                            </div>
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(CandidateBackgroundVerification);
